(function () {
  function positionMegaMenus() {
    // Use the UL as the reference container
    var nav = document.querySelector('nav.site-navigation ul.navigation');
    if (!nav) return;

    var navRect  = nav.getBoundingClientRect();
    var navLeft  = navRect.left;
    var navRight = navRect.right;
    var navWidth = navRect.width;

    nav.querySelectorAll('li.menu-item > ul.submenu').forEach(function (submenu) {
      var li     = submenu.parentElement;
      var liRect = li.getBoundingClientRect();

      // Desired dropdown width (full nav width – adjust if you want narrower)
      var width = navWidth;

      // Try to center under the <li>
      var leftInPage = liRect.left + liRect.width / 2 - width / 2;

      // Clamp so the dropdown never goes outside ul.navigation
      if (leftInPage < navLeft) leftInPage = navLeft;
      if (leftInPage + width > navRight) leftInPage = navRight - width;

      // Convert to coordinates relative to the <li> (its positioned ancestor)
      var leftRelative = leftInPage - liRect.left;

      submenu.style.width = width + 'px';
      submenu.style.left  = leftRelative + 'px';
    });
  }

  document.addEventListener('DOMContentLoaded', positionMegaMenus);
  window.addEventListener('resize', positionMegaMenus);
})();
